import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import React from 'react';
import { useTranslation } from 'next-i18next';

export default function Faqs() {
  // Translation
  const { t } = useTranslation('common');

  const benefits = [
    { id: 1, title: t('premium.talent.hero.faqs.1.question'), text: t('premium.talent.hero.faqs.1.answer') },
    { id: 2, title: t('premium.talent.hero.faqs.2.question'), text: t('premium.talent.hero.faqs.2.answer') },
    { id: 3, title: t('premium.talent.hero.faqs.3.question'), text: t('premium.talent.hero.faqs.3.answer') },
    { id: 4, title: t('premium.talent.hero.faqs.4.question'), text: t('premium.talent.hero.faqs.4.answer') },
  ];

  return (
    <div className="w-full pt-10">
      <div className="mx-auto w-full  rounded-md bg-surface">
        {benefits.map((item, index: number) => (
          <Disclosure as="div" className="border border-solid border-gray-300 p-4" key={item.id} defaultOpen={index === 0}>
            {({ open }) => (
              <>
                <Disclosure.Button className="flex w-full  justify-between p-4 text-left text-lg font-medium text-ink">
                  <h2 className="font-bold">{item.title}</h2>
                  <ChevronDownIcon
                    className={`${
                      open ? 'rotate-180' : ''
                    } size-6 text-ink`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="px-4 py-2 text-md text-ink">
                  {item.text}
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        ))}
      </div>
    </div>
  );
}
